import { GrapevinePostEventsApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useGrapevinePostEventsApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(
    () => new GrapevinePostEventsApi(configuration),
    [configuration]
  );
};
